// /store/ranking/rankingSocket.js
// SIMPLIFIED APPROACH - Just rely on leaderboardUpdate

import { rankingSocket } from "../socket/index";
import {
  setActiveBatches,
  setLeaderboard,
  setTopLeader,
  setError,
  setNextBatch,
} from "./rankingSlice";

// ✅ Setup listeners
export const setupRankingSocketListeners = (dispatch) => {
  rankingSocket.on("connect", () => {
    console.log("✅ Connected to ranking socket");
  });

  rankingSocket.on("activeBatches", (batches) => {
    dispatch(setActiveBatches(batches));
  });

  // top leader Data
  rankingSocket.on("topLeaderData", (data) => {
    dispatch(setTopLeader(data));
  });
  // top leader Data
  rankingSocket.on("nextBatches", (data) => {
    dispatch(setNextBatch(data));
  });

  // 🔹 When user joins batch, server emits initialLeaderboard
  rankingSocket.on("initialLeaderboard", (data) => {
    dispatch(setLeaderboard(data));
  });

  // 🔥 Individual ranking update (for instant feedback)
  rankingSocket.on("rankingUpdate", (updatedStudent) => {
    console.log("⚡ Ranking update received:", updatedStudent);
    // Note: leaderboardUpdate will follow immediately, so we could skip this
    // But keeping it for logging/debugging purposes
  });

  // 🔹 Full leaderboard refresh (THIS is what updates the UI)
  rankingSocket.on("leaderboardUpdate", (data) => {
    dispatch(setLeaderboard(data));
  });

  rankingSocket.on("error", (err) => {
    console.error("❌ Socket error:", err);
    dispatch(setError(err.message || "Socket error"));
  });

  rankingSocket.on("disconnect", () => {
    console.log("❌ Disconnected from ranking socket");
  });
};

// ✅ Emitters
export const joinBatch = (batchCode) => {
  rankingSocket.emit("joinBatch", batchCode);
};

export const leaveBatch = (batchCode) => {
  rankingSocket.emit("leaveBatch", batchCode);
};

export const getLeaderboardUpdate = (batchCode) => {
  rankingSocket.emit("getAllRankings", batchCode);
};

export const getMyRanking = (studentId, batchCode) => {
  rankingSocket.emit("getMyRanking", { studentId, batchCode });
};

// ✅ Cleanup listeners
export const removeRankingListeners = () => {
  const events = [
    "activeBatches",
    "initialLeaderboard",
    "rankingUpdate",
    "leaderboardUpdate",
    "myRanking",
    "error",
  ];
  events.forEach((event) => rankingSocket.off(event));
};
